module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_4_5-d5b9849c5966a7e73db67747c4068ebd.png";